import { DataType, OptionalDataType } from '../DataType';

export function createOptional(type: DataType): OptionalDataType {
    // Flatten Optional<Optional<T>> → Optional<T>
    if (type.kind === 'optional') {
        return type;
    }
    return {
        kind: 'optional',
        innerType: type,
    };
}

export function isOptionalType(type: DataType): type is OptionalDataType {
    return type.kind === 'optional';
}

export function unwrapOptional(type: DataType): DataType {
    if (type.kind === 'optional') {
        return type.innerType;
    }
    return type;
}
